<template lang="pug">
  main
    NavBarPresupuestos
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Nuevo Presupuesto&nbsp
              |
              a.button.is-black.is-rounded(@click='backPage')
                i.fas.fa-times
        .columns
          .column.is-2
            .field
              label.label Periodo del Presupuesto
              .control
                flat-pickr(
                  v-model='periodo'
                  :config="config"
                  class="input"
                )
        .columns
          .column.is-12.has-text-centered
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Seleccionar las cotizaciones para entrar en el presupuesto.&nbsp
                  span.tag.is-success(v-if="itemsSeleccionados.length > 0")
                    | {{ itemsSeleccionados.length }} Seleccionado(s)
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  ListCot_Presupuestos(:cotizaciones='cotizaciones' @countItems="checkItemsSel" @showCotData='showCotData' v-show='Object.keys(cotSel).length === 0')
                  .columns(v-show='Object.keys(cotSel).length > 0')
                    .column.is-6
                      ListCot_PresupuestosSmall(:cotizaciones='cotizaciones' :cotSel='cotSel' @showCotData='showCotData')
                    .column.is-6
                      CardDataCot(:dataCotizacion='cotSel' @hideCotData='hideCotData')
        .columns.has-text-centered
          .column
            a.button.is-black
              | Guardar Presupuesto
        .columns.column-blanco
</template>

<script>
  import NavBarPresupuestos from './layout/NavBarPresupuestos.vue'
  import ListCot_Presupuestos from './componentes/ListCot_Presupuestos.vue'
  import ListCot_PresupuestosSmall from './componentes/ListCot_PresupuestosSmall.vue'
  import CardDataCot from './componentes/CardDataCot.vue'
  import Loader from '../shared/Loader.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'

  import CotizacionesServices from '../../services/inventario/cotizaciones'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"

  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'PresupuestoNuevo',
    components: { Loader, NavBarPresupuestos, BulmaAccordion, BulmaAccordionItem, ListCot_Presupuestos, flatPickr, ListCot_PresupuestosSmall, CardDataCot },
    data() {
      return {
        isLoading: true,
        cotizaciones: [],
        itemsSeleccionados: [],
        periodo: moment().format('YYYY-MM'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only
        },
        cotSel: {}
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerCotizaciones_Presupuestos()
      },
      obtenerCotizaciones_Presupuestos () {
        CotizacionesServices.getCotizaciones_Presupuestos()
          .then( data => {
            this.cotizaciones = data.map(this.convetirData)
            this.cotizaciones.map( cot => {
              cot.items = cot.items.map(this.convertirItems)
              cot.articulos = cot.articulos.map(this.convetirArticulos)
            })
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },
      convetirData (cot) {
        return {
          ...cot,
          concepto: parseInt(cot.concepto),
          estado: parseInt(cot.estado),
          id_cot: parseInt(cot.id_cot),
          id_proveedor: parseInt(cot.id_proveedor),
          moneda: parseInt(cot.moneda),
          tipo: parseInt(cot.tipo),
          iva: Number(cot.iva),
          subtotal: Number(cot.subtotal),
          total: Number(cot.total)
        }
      },
      convertirItems(item) {
        return {
          ...item,
          id_cot_items: parseInt(item.id_cot_items),
          id_proveedor: parseInt(item.id_proveedor),
          moneda: parseInt(item.moneda),
          iva: Number(item.iva),
          subtotal: Number(item.subtotal),
          total: Number(item.total)
        }
      },

      convetirArticulos(art) {
        return {
          ...art,
          cant: parseInt(art.cant),
          estado: parseInt(art.estado),
          id_baseArticulo: parseInt(art.id_baseArticulo),
          id_cot_ts: parseInt(art.id_cot_ts),
          id_ts: parseInt(art.id_ts),
          tipo: parseInt(art.tipo),
          unidadMedida: parseInt(art.unidadMedida),
          importe: Number(art.importe),
          precioUnit: Number(art.precioUnit)
        }
      },

      checkItemsSel() {

      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      showCotData(cot) {
        this.cotSel = cot
      },
      hideCotData() {
        console.log('Here')
        this.cotSel = {}
      },
      backPage () {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/presupuestos_Componentes/PresupuestoNuevo.vue